import { render, staticRenderFns } from "./locationwisereceivable.vue?vue&type=template&id=6cea819d&"
import script from "./locationwisereceivable.vue?vue&type=script&lang=js&"
export * from "./locationwisereceivable.vue?vue&type=script&lang=js&"
import style0 from "./locationwisereceivable.vue?vue&type=style&index=0&id=6cea819d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports